import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Certificado } from './certificado-sii/certificado';
import { FacturadorEle } from './facturador/facturador';
import { ClaveSIIComponent } from './clave-sii/clavesii';
import { SettingsService } from '../settings/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import {
  CertificadoValidacionService, estadoLinea, esReintentable, fechaDia, mensajeCliente, permisosFaltantes,
  PermisosSii, textoErrorValidar, TEXTO_SIN_VERIFICAR,
} from './certificado-sii/certificado-validacion';
declare var $ :any;



@Component({
    selector: 'app-credenciales-sii',
    templateUrl: './credenciales-sii.html',
    styleUrls: ['./credenciales-sii.less'],
    standalone: false
})


export class CredencialesSII implements OnInit {
   
  @Input() id_company:any;
  @Input() se_abrio_como_dialogo = true;
  @Input() token:any;
  @Input() id_sim:any;
  @Input() parent:any;

  valForm: FormGroup;
  data: any;
  business_name:any="";

  constructor(public snackBar: MatSnackBar, 
    private router: Router, public dialog: MatDialog,  
    public settings: SettingsService,private _formBuilder: FormBuilder,
    private changeDetector:ChangeDetectorRef, private validacion: CertificadoValidacionService ){


      this.valForm = this._formBuilder.group({
        clave_sii: [''],
        certificado_sii: [''],
        clave_certificado: [''],
        rut_autorizado: [''],
        facturador: [''],
      });

      this.token = localStorage.getItem('token');

  }

  ngOnInit() {


    this.business_name = localStorage.getItem('business_name')

    // Una sola llamada: el estado de la clave viene en obtener-credenciales-sii (`has_clave_sii`,
    // `status_clave`, `status_clave_reason`). Antes se pedía además `informacionConsultasSII`, que
    // entraba al SII en cada apertura y, si el SII fallaba, mostraba la clave como inválida.
    this.credencialessii();
    this.changeDetector.detectChanges()
  }



  vencio_certificado:boolean=false;
  rut:any;
  clave_pfx:any;
  clave_sii:any;
  file:any;

  success_sii:boolean=false;
  success_certificado:boolean=false;
  success_facturador:boolean=false;
  requiere_completar:boolean=false;
  fecha_vencimiento:any;

  es_mi_pyme:any=null;

  // ── Estado del certificado (bloque `certificado` de obtener-credenciales-sii) ──
  // Lo calcula el backend sin ir al SII. Contrato en LemuBackend `docs/certificado-validacion.md`.
  // Nunca se valida al abrir la pantalla: sólo con «Validar en el SII» o al guardar el certificado.
  certificado: any = null;
  validando: boolean = false;
  aviso_validacion: string = '';

  // ── Estado de la clave SII (`estado_clave` de obtener-credenciales-sii; sin login en el SII) ──
  // El backend decide con la sesión de sii-api y, si no hay, con lo guardado: la misma regla que
  // `valid_clave` en Lemu (LemuBackend `cliente/services/estado_clave_sii.py`).
  // Sin clave → «Cargar clave SII»; válida → check; no válida → aviso con el motivo. Nunca «vacía» si hay clave.
  estado_clave: any = null;

  get clave_estado(): { estado: 'cargando' | 'sin_clave' | 'ok' | 'con_problema', clase: string, icono: string, texto: string } {
    if (this.loading) return { estado: 'cargando', clase: 'estado-neutro', icono: '', texto: '' };
    if (!this.tiene_clave_sii) return { estado: 'sin_clave', clase: 'estado-neutro', icono: 'key', texto: 'Cargar clave SII' };
    // Sin `estado_clave` (backend anterior, o no se pudo calcular): `status_clave`; y si tampoco viene, check.
    const valida = typeof this.estado_clave?.valid_clave === 'boolean' ? this.estado_clave.valid_clave : this.data?.status_clave !== false;
    if (valida) return { estado: 'ok', clase: 'estado-ok', icono: 'check_circle', texto: 'Clave SII cargada' };
    const motivo = this.estado_clave ? this.estado_clave.status_clave_reason : this.data?.status_clave_reason;
    return { estado: 'con_problema', clase: 'estado-alerta', icono: 'error_outline', texto: motivoClaveSii(motivo) };
  }

  get tiene_clave_sii(): boolean {
    if (typeof this.data?.has_clave_sii === 'boolean') return this.data.has_clave_sii;
    return this.clave_sii != null && this.clave_sii != '';
  }

  get cert_estado(): string {
    return this.certificado?.estado || '';
  }

  get cert_linea(): { clase: string, icono: string, texto: string } {
    return estadoLinea(this.certificado);
  }

  // Con problema o vencido: qué pasa y qué hacer, en lenguaje de cliente.
  get cert_detalle(): string {
    if (this.cert_estado == 'vencido') return mensajeCliente('CERTIFICADO_VENCIDO', null, { vence: this.certificado?.vence });
    if (this.cert_estado != 'con_problema') return '';
    const ultima = this.certificado?.ultima_validacion || {};
    return mensajeCliente(ultima.codigo, ultima.mensaje, { vence: ultima.vence, rut_titular: ultima.rut_titular });
  }

  // Válido con aviso (vence pronto, sin MiPyme): el texto del aviso.
  get cert_aviso(): string {
    const ultima = this.certificado?.ultima_validacion;
    if (this.cert_estado == 'valido' && ultima?.codigo && ultima.codigo != 'OK') {
      return mensajeCliente(ultima.codigo, ultima.mensaje, { vence: ultima.vence || this.certificado?.vence });
    }
    if (this.certificado?.vence_pronto && this.cert_estado != 'vencido' && this.certificado?.vence) {
      return `Tu certificado vence el ${fechaDia(this.certificado.vence)}. Renuévalo antes para seguir cediendo.`;
    }
    return '';
  }

  get cert_permisos(): PermisosSii | null {
    if (this.cert_estado != 'con_problema') return null;
    return permisosFaltantes(this.certificado?.ultima_validacion?.permisos);
  }

  // Vigencia junto al estado; no en incompleto (tras subir un .pfx nuevo la fecha es la del anterior).
  get cert_vence(): string {
    if (!['valido', 'sin_validar', 'con_problema'].includes(this.cert_estado)) return '';
    return fechaDia(this.certificado?.vence);
  }

  // Sin el bloque (backend viejo) se deja como antes: el backend responde 403 si no corresponde.
  get puede_editar_certificado(): boolean {
    return this.certificado ? !!this.certificado.puede_editar : true;
  }

  // En sin_cargar / incompleto / vencido el chequeo local ya da la respuesta: no hace falta ir al SII.
  get mostrar_validar(): boolean {
    return !!this.certificado?.puede_validar && ['sin_validar', 'valido', 'con_problema'].includes(this.cert_estado);
  }

  async validar_certificado(evento?: Event) {
    evento?.stopPropagation();
    if (this.validando) return;
    this.validando = true;
    this.aviso_validacion = '';
    try {
      const { status, body } = await this.validacion.validar(this.id_company);
      if (status == 200) {
        // Un reintentable (tope de sesiones, SII caído) no dice nada del certificado: el estado no cambia.
        if (esReintentable(body)) this.aviso_validacion = TEXTO_SIN_VERIFICAR;
        await this.credencialessii();
      } else {
        this.aviso_validacion = textoErrorValidar({ status }, false);
      }
    } finally {
      this.validando = false;
    }
  }

  async credencialessii(){
    try {
      this.loading = this.data == null;



      const bd: any = await this.settings.get_query(1, `cliente/obtener-credenciales-sii/${this.id_company}/`, );
      var body_data: any = bd._body;
      switch (bd.status) {
        case 200:



        this.data = body_data.success.info;
        // `null` si el backend no lo pudo calcular (o es uno viejo): la pantalla sigue como antes.
        this.certificado = body_data.success.certificado || null;
        this.estado_clave = body_data.success.estado_clave || null;
        // Intentos de clave: el diálogo avisa cuántos quedan o hasta cuándo está bloqueada.
        this.bloqueo_clave = body_data.success.bloqueo_clave || null;



        this.rut = this.data.rut_autorizado
        this.clave_pfx = this.data.clave_pfx
        this.clave_sii = this.data.clave_sii
        this.vencio_certificado = this.data.activate_certificado;
        this.file = this.data.archivo_pfx;
        this.fecha_vencimiento = this.data.certificado_fecha;

        if(this.clave_sii != null && this.clave_sii != "" && this.clave_sii != undefined){
            this.valForm.controls['clave_sii'].setValue(this.clave_sii)
            this.success_sii = true;
        }

        if(this.file != null && this.file != "" && this.file != undefined && this.clave_pfx != null 
            && this.clave_pfx != "" && this.clave_pfx != undefined 
            && this.rut != null && this.rut != "" && this.rut != undefined){
            this.success_certificado = true;
            this.requiere_completar = false
        }else{
            this.requiere_completar = true
        }

        if(this.file != null && this.file != "" && this.file != undefined){
            this.valForm.controls['certificado_sii'].setValue(this.file)
        }


        if(this.data.facturador != null){
            this.valForm.controls['facturador'].setValue(this.data.facturador.name)
            this.success_facturador = true;


            if(this.data.facturador.name == "MiPyme"){
              this.es_mi_pyme = true;
            }else{
              this.es_mi_pyme = false;
            }

        }



        break;
        default:

        break;
      }

    } catch (bd:any) {

      switch (bd.status) {
        case 500:

            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });
          break;

        case 400:

            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });
          break;
        default:

            this.snackBar.open('Ocurrió un error, intenta de nuevo', 'Aceptar', {
              duration: 20000,
              panelClass: 'simpli-snack'
            });

        break;
      }
    } finally {
      this.loading = false;
    }
  }

  //CLAVE SII
  dialogSii:any;
  bloqueo_clave: any = null;
  change_sii() {
    this.dialogSii = this.dialog.open(ClaveSIIComponent,{
      width: '600px',
      minHeight: '630px',
      autoFocus: false,
    });
    this.dialogSii.componentInstance.id_company = this.id_company
    this.dialogSii.componentInstance.data = this.data;
    this.dialogSii.componentInstance.token = this.token;
    this.dialogSii.componentInstance.parent = this;
    this.dialogSii.componentInstance.bloqueo = this.bloqueo_clave;


    this.dialogSii.afterClosed().subscribe((result:any) => {
      this.credencialessii()
    });
  }

  //Certificado
  change_certificado() {
    if (!this.puede_editar_certificado) return;
    const dialogRef = this.dialog.open(Certificado,{
      width: '600px',
      minHeight: '630px',
      autoFocus: false,
    });
    dialogRef.componentInstance.id_company = this.id_company
    dialogRef.componentInstance.data = this.data;
    dialogRef.componentInstance.token = this.token;
    dialogRef.componentInstance.id_sim = this.id_sim;

    dialogRef.afterClosed().subscribe((result:any) => {
      this.credencialessii()
    });
  }



  //Facturador
  change_facturador() {
    const dialogRef = this.dialog.open(FacturadorEle,{
      width: '600px',
      minHeight: '630px',
      autoFocus: false,
    });
    dialogRef.componentInstance.id_company = this.id_company
    dialogRef.componentInstance.data = this.data
    dialogRef.componentInstance.token = this.token;


    dialogRef.afterClosed().subscribe((result:any) => {
      this.credencialessii();
    });
  }

  loading:boolean=true;

}


/**
 * `Company.status_clave_reason` en lenguaje de cliente. Lo escribe Lemu al guardar o validar la clave
 * (`tubo/views/tuboSiiCredentialCallbackView.py`). Cualquier otro valor —o ninguno— es «no sabemos por
 * qué»: se pide volver a ingresarla, que es lo que la valida.
 */
export function motivoClaveSii(motivo: string | null | undefined): string {
  switch (motivo) {
    case 'wrong_password':
      return 'El SII rechazó la clave guardada. Vuelve a ingresarla.';
    case 'blocked':
      return 'Tu clave está bloqueada en el SII. Desbloquéala en sii.cl y vuelve a ingresarla.';
    case 'max_sessions':
      return 'El SII tiene demasiadas sesiones abiertas con tu clave. Intenta más tarde.';
    default:
      return 'No pudimos verificar tu clave en el SII. Vuelve a ingresarla para validarla.';
  }
}
